import {
  Schedule as AccessTimeOutlinedIcon,
  Report as AssessmentOutlinedIcon,
  EventAvailable as EventAvailableOutlinedIcon,
  People as GroupsOutlinedIcon,
} from "components/icons";

import { BrandLogo } from "app/components/brand/BrandLogo";
import "./AuthLayout.css";

// @since NEXT_VERSION
const FEATURES = [
  {
    title: "Timesheets",
    text: "Log daily activities, one or several at a time, and send them for approval.",
    Icon: AccessTimeOutlinedIcon,
  },
  {
    title: "Leave and holidays",
    text: "Plan leave and see the holiday calendar that applies to each client.",
    Icon: EventAvailableOutlinedIcon,
  },
  {
    title: "Teams and clients",
    text: "Members, managers and clients, each with the access their role needs.",
    Icon: GroupsOutlinedIcon,
  },
  {
    title: "Reports",
    text: "Utilization and timesheet reports, exported in each client's own format.",
    Icon: AssessmentOutlinedIcon,
  },
];

// The logo's mark, drawn large and faint behind the panel: traces rising from a swoosh, each
// ending in a dot. Decorative only.
const BrandMotif = () => (
  <svg className="auth-brand-motif" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
    <g fill="none" stroke="currentColor" strokeWidth="18" strokeLinecap="round">
      <path d="M118 400 V262" />
      <path d="M190 400 V182" />
      <path d="M262 400 V250 Q262 214 300 196" />
      <path d="M30 318 Q190 430 392 286" />
    </g>
    <g fill="currentColor">
      <circle cx="118" cy="234" r="22" />
      <circle cx="190" cy="154" r="22" />
      <circle cx="326" cy="184" r="22" />
    </g>
  </svg>
);

/**
 * The sign-in screens' split layout: the HRMS brand panel on the left and the page's form on the
 * right, with the logo centred above the form. Below 900px the panel gives way to the form.
 *
 * @since NEXT_VERSION
 */
export const AuthLayout = ({ children }) => (
  <div className="auth-layout">
    <aside className="auth-brand" aria-label="About InOpTra HRMS">
      <BrandMotif />
      <div className="auth-brand-inner">
        <BrandLogo tone="on-ink" className="auth-brand-logo" />
        <h1 className="auth-headline">Your teams&rsquo; time, leave and reports, in one place.</h1>
        <p className="auth-tagline">
          InOpTra HRMS: timesheets, leave planning, team management and client reporting.
        </p>
        <ul className="auth-features">
          {FEATURES.map(({ title, text, Icon }) => (
            <li key={title} className="auth-feature">
              <span className="auth-feature-icon">
                <Icon fontSize="small" />
              </span>
              <h2 className="auth-feature-title">{title}</h2>
              <p className="auth-feature-text">{text}</p>
            </li>
          ))}
        </ul>
      </div>
    </aside>
    <main className="auth-main">
      <div className="auth-form-column">
        <BrandLogo className="auth-form-logo" />
        {children}
      </div>
    </main>
  </div>
);
